import { render } from "./TaskB.vue?vue&type=template&id=20f6f26d&ts=true"
import script from "./TaskB.vue?vue&type=script&lang=ts"
export * from "./TaskB.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__